import { ResourceOptions } from 'react-admin';
import '../dataProvider';
import { Resources } from '../../resource';

// Proxy scores are shown as a tab inside the Proxy Manager page.
export const name = Resources.proxyManagerProxyScores;
export const options: ResourceOptions = {
  label: 'resource.proxyManagerProxyScores',
};
